module.exports = __webpack_public_path__ + "img/completed-animated.e4bdbc4c.svg";